export default function Footer() {
  return (
    <footer className="bg-black border-t border-white/10 py-8">
      <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-white/30 text-xs text-center font-poppins">
          © 2026 Andrés Cadena. Todos los derechos reservados. | Diseñado por Lion Urban Design Print
        </p>
      </div>
    </footer>
  );
}
